export const CORS_ENABLING_URL =
  'https://2bn4rt06h5.execute-api.us-east-1.amazonaws.com/dev/unlock?url=';
export const STOCKTWITS_URL =
  'https://api.stocktwits.com/api/2/streams/symbol/';
